import { render, staticRenderFns } from "./notapproved.vue?vue&type=template&id=ec752baa"
import script from "./notapproved.vue?vue&type=script&lang=js"
export * from "./notapproved.vue?vue&type=script&lang=js"
import style0 from "./notapproved.vue?vue&type=style&index=0&id=ec752baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports